"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  core: {
    modals: {
      components: {
        confirmDialog: {
          yes: 'Yes',
          no: 'No',
          cancel: 'Cancel',
          ok: 'Ok',
          save: 'Save',
          confirm: 'Confirm'
        }
      }
    }
  }
});